import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import PopupRef from '../../component/PopupRef';
import { FILE_TYPE } from '../../constant/Constant';

const ExcelUploadButtonBox = ({
    title = '엑셀 업로드',
    module,
    params,
    callback,
    availableTypes = [FILE_TYPE.EXCEL],
}) => {
    const fileUploadInput = useRef();
    const dispatch = useDispatch();
    const popupRef = useRef(null);

    const _uploadFileHandler = (e) => {
        if (e.target.files.length > 1) {
            popupRef.current.openAlert('파일 첨부는 최대 1개까지만 가능합니다.');
            return;
        }

        if (e.target.files[0]) {
            const [file] = e.target.files;
            console.log('FILE-TYPE: ' + file.type);
            if (!availableTypes.includes(file.type)) {
                popupRef.current.openAlert('엑셀 파일만 업로드 가능합니다.');
            } else {
                dispatch(
                    module({
                        params: {
                            ...params,
                            file,
                        },
                        callback: () => {
                            popupRef.current.openInfo('정상 처리 되었습니다.', () => {
                                return function () {
                                    callback();
                                };
                            });
                        },
                    }),
                );
            }
        }
    };

    const handleOnClickUploadFile = (e) => {
        fileUploadInput.current.value = '';
        fileUploadInput.current.click();
    };

    return (
        <>
            <input
                type='file'
                id='input-file'
                style={{ display: 'none' }}
                multiple='multiple'
                ref={fileUploadInput}
                onChange={(e) => _uploadFileHandler(e)}
            />
            <button
                type='button'
                className='btn btn-common upload mr10'
                onClick={(e) => handleOnClickUploadFile(e)}
            >
                {title}
            </button>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default ExcelUploadButtonBox;
